import React from 'react'
import PropTypes from 'prop-types'
import FileInput from '../../shared/FileInput'
import RadioButton from '../../ui/RadioButton'

const getAcceptType = variableType => {
  if (variableType === 'pdf')
    return '.pdf'
  if (variableType === 'image')
    return 'image/png, image/jpeg'
  return '*'
}

const FileVariableInput = ({
  clearFile,
  errors,
  fileName,
  variableId,
  variableType,
  onCancelClear,
  onChange,
  onClear,
  onDelete
}) => {
  const radioName = `file-action-${variableId}`

  return (
    <div>
      <RadioButton
        checked={clearFile}
        id={`${radioName}-clear`}
        label="Supprimer les fichiers"
        name={radioName}
        value="clear"
        onChange={onClear}
      />
      <RadioButton
        checked={!clearFile}
        className="mt-2"
        id={`${radioName}-replace`}
        label="Remplacer les fichiers par"
        name={radioName}
        value="replace"
        onChange={onCancelClear}
      />
      {clearFile ? null : (
        <div className="mt-2">
          <FileInput
            accept={getAcceptType(variableType)}
            errors={errors}
            value={fileName}
            onChange={onChange}
            onDelete={onDelete}
          />
        </div>
      )}
    </div>
  )
}

FileVariableInput.propTypes = {
  clearFile: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
  fileName: PropTypes.string,
  onCancelClear: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  variableId: PropTypes.number.isRequired,
  variableType: PropTypes.string.isRequired
}

FileVariableInput.defaultProps = {
  clearFile: false,
  errors: [],
  fileName: ''
}

export default FileVariableInput
